import $ from 'gridstrap/lib/gs-zepto';

export class GSHoverCta {
	private root;
	private header;
	private detail;

	set isInitialized(value) { this.root.toggleClass('is-initialized', !!value); }

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.header = this.root.find('.gs-HoverCta-header');
		this.detail = this.root.find('.gs-HoverCta-detail');
	}

	gsOnInit() {
		const width = this.header.width();
		this.detail.css('max-width', `${width}px`);
		this.isInitialized = true;
		console.log('Hover CTA initialized!');
	}

}
